// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import axios from 'axios';
import Vue from 'vue';
import store from './store';
// import ElementUI from 'element-ui';
import {
  Pagination,
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Input,
  Radio,
  Checkbox,
  CheckboxGroup,
  Switch,
  Select,
  Option,
  Button,
  Table,
  TableColumn,
  DatePicker,
  Popover,
  Tooltip,
  Tag,
  Icon,
  Upload,
  Collapse,
  CollapseItem,
  Cascader,
  Loading,
  Message
} from 'element-ui';

// eslint-disable-next-line
import vueiInfinite from 'vue-infinite-scroll';
import 'vue-orgchart/dist/style.min.css';

import '@babel/polyfill';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import authService from '@/services/authService';
import App from './App';
import router from './router';
import filter from './filter';
import './main.scss';
import { AUTH_TOKEN_TYPE, AUTO_LOGOUT_PATH } from '@/helpers/constants';
import localStorageHelper from '@/helpers/localStorageHelper';

Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Input);
Vue.use(Radio);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Switch);
Vue.use(Select);
Vue.use(Option);
Vue.use(Button);
Vue.use(Table);
Vue.use(DatePicker);
Vue.use(TableColumn);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(Tag);
Vue.use(Icon);
Vue.use(Upload);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Cascader);

Vue.use(Loading.directive);
filter.init(Vue);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message;


// Vue.use(ElementUI);
Vue.use(vueiInfinite);

Vue.config.productionTip = false;
Vue.component(CollapseTransition.name, CollapseTransition);
// Vue.prototype.$message = ElementUI.Message;
// use interceptor to add auth token to every request exception login

axios.interceptors.request.use(config => {
  if (config.url.indexOf('/api/login') === -1) {
    const authToken = authService.getAuthToken();
    const authTelNumber = authService.getAuthTelNumber();
    if (authToken) {
      config.headers.Authorization = authToken;
      config.headers['User-Key'] = authTelNumber;
    }
  }
  const authType = authService.getAuthTokenType();
  if (authType && authType === 'cicc') {
    config.headers.Source = 'cicc';
  } else {
    config.headers.Source = 'shannonai';
  }
  return config;
});

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response.status === 401) {
      const authType = authService.getAuthTokenType();
      const currentUrl = router.currentRoute.fullPath;
      localStorageHelper.setItem(AUTO_LOGOUT_PATH, currentUrl);
      if (currentUrl.indexOf('/new-login') === -1) {
        if (authType && authType === 'cicc') {
          localStorageHelper.removeItem(AUTH_TOKEN_TYPE);
          const a = document.createElement('a');
          // a.setAttribute('href', 'http://localhost:8080/#/new-login');
          // a.setAttribute('href', 'http://10.20.31.205:8018/#/new-login');
          a.setAttribute('href', 'http://inews-cicc.shannonai.com/#/new-login');
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          router.push({
            path: '/new-login',
            query: {
              redirect: currentUrl
            }
          });
        }
      }
    }
    return Promise.reject(error);
  }
);

window.eventBus = new Vue();

/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// });

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app');
